module.exports = __webpack_public_path__ + "static/kite-c4413912611347a84e8e5d6328e83cd8.jpg";